<template>
  <div>
    <teleport to="body">
      <div
        id="snackbar"
        :class="[
          { show: show },
          { successToast: type },
          { failureToast: !type }
        ]"
      >
        {{ msg }}
      </div>
    </teleport>
  </div>
</template>

<script>
export default {
  props: ["show", "msg", "type"]
};
</script>

<style scoped>
#snackbar {
  visibility: hidden;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  padding: 16px;
  position: fixed;
  z-index: 1;
  left: 30%;
  width: 40%;
  top: 30px;
  font-size: 17px;
  opacity: 0.9;
}

#snackbar.show {
  visibility: visible;
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

.successToast {
  background-color: #059669;
}

.failureToast {
  background-color: #dc2626;
}

@-webkit-keyframes fadein {
  from {
    top: 0;
    opacity: 0;
  }
  to {
    top: 30px;
    opacity: 1;
  }
}

@keyframes fadein {
  from {
    top: 0;
    opacity: 0;
  }
  to {
    top: 30px;
    opacity: 1;
  }
}

@-webkit-keyframes fadeout {
  from {
    top: 30px;
    opacity: 1;
  }
  to {
    top: 0;
    opacity: 0;
  }
}

@keyframes fadeout {
  from {
    top: 30px;
    opacity: 1;
  }
  to {
    top: 0;
    opacity: 0;
  }
}
</style>
